import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import 'styles/Modal.css';
import { IconClose } from 'icons';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  contentLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  showClose: PropTypes.bool,
};

const defaultProps = {
  showClose: false,
};

function Modal(props) {
  const modalClasses = props.showClose
    ? 'Modal--after-open Modal--landing-page'
    : 'Modal--after-open';
  return (
    <ReactModal
      isOpen={props.isOpen}
      contentLabel={props.contentLabel}
      onRequestClose={props.onRequestClose}
      closeTimeoutMS={500}
      className={{
        base: 'Modal',
        afterOpen: modalClasses,
        beforeClose: 'Modal--before-close',
      }}
      overlayClassName={{
        base: 'Overlay',
        afterOpen: 'Overlay--after-open',
        beforeClose: 'Overlay--before-close',
      }}
    >
      {props.showClose && (
        <button onClick={props.onRequestClose} className="Modal__Close">
          <IconClose />
        </button>
      )}
      {props.children}
    </ReactModal>
  );
}

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default Modal;



// WEBPACK FOOTER //
// ./src/components/shared/Modal/Modal.jsx